"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = void 0;

var _victor = _interopRequireDefault(require("victor"));

var time = _interopRequireWildcard(require("./time"));

var _physics = _interopRequireWildcard(require("./physics"));

var _utils = require("./utils");

var _state2 = require("./state");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Vector = _victor.default;

class Player extends _physics.GameObject {
  constructor() {
    super(); //Did the player recently die?

    this.dead = false;
    this.invincibleTimer = 0; //Player input tracking.  Everything is false/blank by default

    this.moveHeading = (0, _utils.randomVec)();
    this.sprint = false;
    this.sprintTimer = 0; //snake data

    this.bodySpacing = 1.8; //Player sprite

    this.spriteName = undefined; //Score

    this.score = 0;
  }

  update(_state) {
    if (!this.dead) {
      //Rotate towards heading, clamp degrees so you can't turn around on the spot
      this.accel = this.vel.clone().normalize();
      const angleDiff = 180 + this.moveHeading.angleDeg() - (180 + this.accel.angleDeg());
      const angleDir = angleDiff > 0 ? 1 : -1;
      const clampedDegToRotate = (0, _utils.clamp)(Math.abs(angleDiff), 0, 90) * (Math.abs(angleDiff) > 180 ? -angleDir : angleDir);
      this.accel.rotateDeg(clampedDegToRotate).multiplyScalar(_state2.GLOBALS.baseAccelSpeed * (this.sprint ? _state2.GLOBALS.sprintMult : 1)); //Add acceleration to the velocity scaled by dt.  Limit the velocity so collisions don't break

      this.vel.add(this.accel.multiplyScalar(time.dt(_state))); //limit velocity with current max speed (squared since its cheaper)

      const currentMaxSpeed = this.sprint ? _state2.GLOBALS.sprintMult * _state2.GLOBALS.sprintMult * _state2.GLOBALS.baseMoveSpeed * _state2.GLOBALS.baseMoveSpeed : _state2.GLOBALS.baseMoveSpeed * _state2.GLOBALS.baseMoveSpeed;

      if (this.vel.lengthSq() > currentMaxSpeed) {
        this.vel.normalize().multiplyScalar(this.sprint ? _state2.GLOBALS.baseMoveSpeed * _state2.GLOBALS.sprintMult : _state2.GLOBALS.baseMoveSpeed);
      } //Add velocity to the position scaled by dt


      this.pos.add(this.vel.clone().multiplyScalar(time.dt(_state))); //Sprint decreases snake length. If snake is too short, stop sprinting

      if (this.sprint) {
        if (this.sprintTimer % 30 === 0 && this.score > 0) {
          this.score = Math.max(0, this.score - _state2.GLOBALS.sprintCostPerSecond / 2);
          this.collider.updateBodyWithScore();
        }

        this.sprintTimer = (this.sprintTimer + 1) % 30;
      } else {
        this.sprintTimer = 0;
      } //Update invincibleTimer


      if (this.invincibleTimer > 0.01) {
        this.invincibleTimer -= time.dt(_state);
      } //Reset acceleration


      this.accel = new Vector(0.0, 0.0);
      this.collider?.update();
    }
  }

  isOutOfBounds(_state) {
    return this.collider.isOutOfBounds(_state);
  }

  getData() {
    return { ...super.getData(),
      dead: this.dead,
      name: this.name,
      spriteName: this.spriteName,
      moveHeadingX: this.moveHeading.x,
      moveHeadingY: this.moveHeading.y,
      sprint: this.sprint,
      sprintTimer: this.sprintTimer,
      invincibleTimer: this.invincibleTimer,
      score: this.score
    };
  }

  getServerUpdateData() {
    return {
      id: this.id,
      name: this.name,
      spriteName: this.spriteName,
      dead: this.dead,
      x: this.pos.x,
      y: this.pos.y,
      moveHeadingX: this.moveHeading.x,
      moveHeadingY: this.moveHeading.y,
      sprint: this.sprint,
      sprintTimer: this.sprintTimer,
      score: this.score,
      collider: this.collider?.getServerUpdateData()
    };
  }

  getClientUpdateData() {
    return {
      id: this.id,
      x: this.pos.x,
      y: this.pos.y,
      velX: this.vel.x,
      velY: this.vel.y,
      name: this.name,
      spriteName: this.spriteName,
      moveHeadingX: this.moveHeading.x,
      moveHeadingY: this.moveHeading.y,
      sprint: this.sprint,
      sprintTimer: this.sprintTimer
    };
  }

  setClientDataFromServerUpdate(_data) {
    this.dead = _data.dead !== undefined ? _data.dead : this.dead;
    this.spriteName = _data.spriteName !== undefined ? _data.spriteName : this.spriteName;
    this.score = _data.score !== undefined ? _data.score : this.score;
  }

  setData(_data) {
    super.setData(_data);
    this.name = _data.name !== undefined ? _data.name : this.name;
    this.spriteName = _data.spriteName !== undefined ? _data.spriteName : this.spriteName;
    this.dead = _data.dead !== undefined ? _data.dead : this.dead;
    this.moveHeading = new Vector(!isNaN(_data.moveHeadingX) ? _data.moveHeadingX : this.moveHeading.x, !isNaN(_data.moveHeadingY) ? _data.moveHeadingY : this.moveHeading.y);
    this.sprint = _data.sprint !== undefined ? _data.sprint : this.sprint;
    this.sprintTimer = !isNaN(_data.sprintTimer) ? _data.sprintTimer : this.sprintTimer;
    this.invincibleTimer = !isNaN(_data.invincibleTimer) ? _data.invincibleTimer : this.invincibleTimer;
    this.score = !isNaN(_data.score) ? _data.score : this.score;

    if (this.renderer) {
      this.renderer.playerName = this.name;
      this.renderer.spriteName = this.spriteName;
      this.renderer.parent = this;
    }

    return this;
  }

}

exports.Player = Player;